import { render, staticRenderFns } from "./talentManage.vue?vue&type=template&id=10f64e2b&scoped=true"
import script from "./talentManage.vue?vue&type=script&lang=js"
export * from "./talentManage.vue?vue&type=script&lang=js"
import style0 from "./talentManage.vue?vue&type=style&index=0&id=10f64e2b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f64e2b",
  null
  
)

export default component.exports